import { useEffect } from 'react'
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const useVisitorId = () => {

    useEffect(() => {
        if(localStorage.getItem("visitorId")) return;
        FingerprintJS.load()
        .then(fp => fp.get())
        .then(({ visitorId }) => localStorage.setItem("visitorId", visitorId))
    }, [])
    
    return;
}
